// When to offer a new version, and how to switch to it.
//
// A pure module paired with UpdateBanner.js. See service-worker.js for why a
// new version waits to be asked for rather than activating itself.

// The two screens where an athlete is logging. A banner there takes a tap
// meant for "Log set", and pressing it reloads the page with an unsaved row
// in it. The offer waits for the next screen.
const LOGGING_ROUTES = [
  /^\/programs\/[^/]+\/sessions\/[^/]+\/train\/?$/,
  /^\/programs\/[^/]+\/sessions\/[^/]+\/log\/?$/,
];

export function offersUpdate(pathname) {
  return !LOGGING_ROUTES.some((route) => route.test(pathname || ''));
}

/**
 * Activate the waiting worker, then reload once it controls the page.
 *
 * The reload waits for controllerchange. Reloading straight away would load the
 * page again under the OLD worker, which is still active until the new one takes
 * over. The athlete would press Reload and still be on the old version. The
 * `once` guard stops a second controllerchange (another tab updating) from
 * reloading twice.
 */
export function applyUpdate(registration, win = window) {
  const waiting = registration?.waiting;
  if (!waiting) return false;

  let reloaded = false;
  win.navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloaded) return;
    reloaded = true;
    win.location.reload();
  });
  waiting.postMessage({ type: 'SKIP_WAITING' });
  return true;
}

// The waiting registration, shared between index.js (which learns about it) and
// UpdateBanner (which offers it). A tiny store instead of context: registration
// happens outside React, before the tree mounts.
let waitingRegistration = null;
const listeners = new Set();

export function setWaiting(registration) {
  waitingRegistration = registration;
  listeners.forEach((listener) => listener(registration));
}

export function getWaiting() {
  return waitingRegistration;
}

export function subscribeWaiting(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
